import ReactGA from "react-ga4";
export const trackGA4Event = function (eventName:string, properties:any) {
  ReactGA.event(eventName, properties);
};


